import React, { useEffect } from "react";
import TagManager from 'react-gtm-module';

import "./App.css";
import { ReactComponent as Logo } from "./logo.svg"; // Ensure the SVG file is in src/

function App() {
  useEffect(() => {
    const tagManagerArgs = { gtmId: 'GTM-NZK9TWT5' }; // Replace with your GTM ID
    TagManager.initialize(tagManagerArgs);
  }, []);

  return (
    <div className="app theme-white">
      {/* Header with logo and login */}
      <header className="header">
        <Logo className="logo" />
        
      </header>

      {/* Main content with iframe */}
      <main className="main-content">
        <iframe  
          src='https://wiz.directferries.com/partners/deal_finder_iframe.aspx?stdc=F7907&cult=en-GB&btn=47a347&btnh=168b16&btnt=FFFFFF&tclr=FFFFFF&lclr=000001&lbld=400&pclr=64b6e6&sclr=64b6e6&targ=0' // Replace with your iframe URL
          title="Main Content"
          className="iframe-content"
        />
      </main>

      {/* Footer with hygiene links 
      <footer className="footer">
        <a href="/privacy">Privacy Policy</a>
        <span> | </span>
        <a href="/terms">Terms & Conditions</a>
        <span> | </span>
        <a href="/contact">Contact Us</a>
      </footer>*/}
    </div>
  );
}

export default App;
